<template>
  <div>
    <b-modal
      id="modal-confirm"
      ref="modal-confirm"
      title="Are you sure you want delete this result?"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
    >
      <div v-if="!snippetDeleted">
        <b-button class="mt-2 ml-auto" variant="secondary" @click="cancelModal"
          >Cancel
        </b-button>
        <b-button
          class="mt-2 ml-3"
          variant="danger"
          @click="deleteSnippet(snippet.id)"
          >Delete result
        </b-button>
      </div>
      <div v-if="snippetDeleted">
        <b-alert variant="success" show>Result deleted.</b-alert>
        <div class="text-right">
          <b-button class="mt-2" variant="primary" @click="cancelModal"
            >Close
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SnippetModal',
  data() {
    return {
      snippetDeleted: false,
    };
  },
  computed: {
    ...mapGetters(['snippet', 'modalConfirm']),
  },
  watch: {
    modalConfirm(status) {
      if (status) {
        this.$refs['modal-confirm'].show();
      } else {
        this.$refs['modal-confirm'].hide();
      }
    },
  },
  methods: {
    resetSnippet() {
      this.snippetDeleted = false;
    },
    deleteSnippet() {
      this.snippetDeleted = true;
      const deletePayload = {
        snippetId: this.snippet.id,
        hitIdx: null,
      };
      this.$store.dispatch('DESTROY_SNIPPET', deletePayload);
    },
    cancelModal() {
      this.$store.commit('SHOW_MODAL_CONFIRM_SNIPPET', {
        status: false,
        id: '',
      });
      this.resetSnippet();
    },
  },
};
</script>
